/* tslint:disable */
/* eslint-disable */
/**
 * acomo API docs
 * acomoのAPI仕様書です。
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const PresetSystemActionType = {
    Administrate: 'administrate',
    Manage: 'manage',
    Use: 'use',
    Develop: 'develop'
} as const;
export type PresetSystemActionType = typeof PresetSystemActionType[keyof typeof PresetSystemActionType];


export function instanceOfPresetSystemActionType(value: any): boolean {
    for (const key in PresetSystemActionType) {
        if (Object.prototype.hasOwnProperty.call(PresetSystemActionType, key)) {
            if (PresetSystemActionType[key as keyof typeof PresetSystemActionType] === value) {
                return true;
            }
        }
    }
    return false;
}

export function PresetSystemActionTypeFromJSON(json: any): PresetSystemActionType {
    return PresetSystemActionTypeFromJSONTyped(json, false);
}

export function PresetSystemActionTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresetSystemActionType {
    return json as PresetSystemActionType;
}

export function PresetSystemActionTypeToJSON(value?: PresetSystemActionType | null): any {
    return value as any;
}

export function PresetSystemActionTypeToJSONTyped(value: any, ignoreDiscriminator: boolean): PresetSystemActionType {
    return value as PresetSystemActionType;
}

